import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Presentation } from '../../../domain/presentation/model/presentation';
import { PresentationFacadeService } from '../../../domain/presentation/service/presentation-facade.service';

export const presentationResolver: ResolveFn<Presentation> = (route: ActivatedRouteSnapshot) => {
  const facade = inject(PresentationFacadeService);
  return facade.getPresentation(
    route.paramMap.get('sessionId')!,
    route.paramMap.get('presentationId')!,
  );
};
